import React from "react";
import { IntlProvider } from "react-intl";
import { getLang, getMessages } from "../i18n/i18nDataBuilder";

export function withIntlRootProvider<P>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
	class Wrapper extends React.Component<P> {
		render() {
			return (
				<IntlProvider locale={getLang()} messages={getMessages()}>
					<WrappedComponent {...this.props} />
				</IntlProvider>
			);
		}

		static readonly displayName = `withIntlRoot(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
	}

	return Wrapper;
}
